export default "__VITE_ASSET__DK$YaBCS__"